export const selectThemeById = (state, themeId) => state.theme.themes[themeId];

export const selectDefaultTheme = state => selectThemeById(state, 'default');

